<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ data?.title || t('Note') }}</h2>

  <div class="wrapper content">
    <div class="note-list">
      <div class="note-row">
        <p>{{ t('Creation date') }}</p>
        <div class="value">
          {{ data?.createdDateTimeUtc | localDate: 'fullDate' : lang() }}
        </div>
      </div>

      <hr class="note-divider" />

      <div class="note-row">
        <p>{{ t('Author') }}</p>
        <div
          class="value"
          [innerHTML]="
            (
              (data?.veterinarian?.firstName || '') +
              ' ' +
              (data?.veterinarian?.lastName || '')
            ).trim() || t('Clinic Owner') | emptyFallbackHtml
          "
        ></div>
      </div>

      <hr class="note-divider" />

      <div class="note-row">
        <p>{{ t('Title') }}</p>
        <div
          class="value"
          [matTooltip]="data?.title"
          matTooltipShowDelay="200"
          matTooltipPosition="above"
          [innerHTML]="data?.title | emptyFallbackHtml"
        ></div>
      </div>

      <hr class="note-divider" />

      <div class="note-row">
        <p>{{ t('Description') }}</p>
        <div
          class="value"
          [matTooltip]="data?.description"
          matTooltipShowDelay="200"
          matTooltipPosition="above"
          [innerHTML]="data?.description | emptyFallbackHtml"
        ></div>
      </div>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="closeDialog()" class="secondary-btn">
      {{ t('Close') }}
    </button>
  </mat-dialog-actions>
</ng-container>
